import { render, staticRenderFns } from "./TableHistoryNew.vue?vue&type=template&id=3565b416"
import script from "./TableHistoryNew.vue?vue&type=script&lang=js"
export * from "./TableHistoryNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports